import { gql } from '@apollo/client';

export const CREATE_UTILITY_ACCOUNT_BILL_EXTRACTION = gql`
  mutation Flex_CreateUtilityAccountBillExtraction(
    $input: CreateUtilityAccountBillExtractionInput!
  ) {
    createUtilityAccountBillExtraction(input: $input) {
      id
    }
  }
`;
